import React from "react";
import { Box, Tooltip, Typography } from "@mui/material";

export const STORAGE_LIMIT_TOOLTIP =
    "Each account can store up to 100 purchased files on the Botmark website. To download more, delete files you no longer need. Files you send out don't count toward this limit.";

export const StorageLimitIndicator = ({
    count,
    tooltip = STORAGE_LIMIT_TOOLTIP,
}) => {
    if (count === undefined || count === null) return null;

    let color = "green";
    if (count >= 100) color = "red";
    else if (count >= 90) color = "orange";

    return (
        <Box
            component="span"
            sx={{
                display: "inline-flex",
                alignItems: "flex-start",
            }}
        >
            <Typography component="span" sx={{ color, fontWeight: "bold" }}>
                {count}
            </Typography>
            <Tooltip title={tooltip} placement="top" arrow>
                <Typography
                    component="sup"
                    aria-label="Storage limit info"
                    sx={{
                        cursor: "help",
                        color: "#666",
                        fontSize: "0.7em",
                        marginLeft: "2px",
                        verticalAlign: "super",
                        display: "inline-block",
                        position: "relative",
                        top: "-0.35em",
                    }}
                >
                    ⓘ
                </Typography>
            </Tooltip>
        </Box>
    );
};
